<template>
<div >
  <div class="row">
        <div class="flex xs12 sm12 lg9">
          <h1>{{ $t('gestaoconteudo.Audios') }}</h1>
        </div>
        <div class="flex xs12 sm12 lg3">
          <va-button class="text-right" @click="abrirNovo()"  :color="BuNovo.color" :style="BuNovo"> {{ $t('Geral.Novo') }}</va-button>
        </div>
  </div>

  <div v-if="novo">
          
              <div class="row">
                <div class="flex md3 sm12 xs12 text-center">
                  <va-input
                    v-model="arquivo.nome"
                    placeholder="Nombre "
                  />
                </div>
                <div class="flex md3 sm12 xs12">
                  
                    <va-select
                      :label="$t('forms.selects.simple')"
                      v-model="arquivo.disciplina"
                      textBy="nome"
                      :options="allDisciplinas"
                      placeholder="Disciplina"
                    />
                    
                
                  </div>
                 <div class="flex md3 sm6 xs12 text-center">
                      <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
                       <!-- <va-file-upload
                        v-model="arquivo.status"
                        type="file"
                        v-on:change="onFileChange()"
                       
                      />  -->
                </div>
                <div class="flex md3 sm12 xs12 text-center">
                    <va-button class="text-right"  v-on:click="submitFile()"  color="dark"> {{ $t('Geral.Salvar') }}</va-button>
                </div>
              </div>

          

            <!-- <label>File
        <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
      </label>
      <button v-on:click="submitFile()">Submit</button> -->

  </div>
 
    <va-data-table
          :fields="fields"
          :data="allArquivos"
          hoverable
          no-pagination
          >
              <template slot="marker" slot-scope="props">
                <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
              </template>

              <template slot="actions" slot-scope="props">
                <va-button flat small color="gray" @click="edit(props.rowData)" class="ma-0">
                  {{ $t('tables.edit') }}
                </va-button>

                <va-button flat small color="danger" @click="remove(props.rowData)" class="ma-0">
                  {{ $t('tables.delete') }}
                </va-button>
              </template>
              
        </va-data-table>

   <preloader></preloader>

</div>

</template>

<script>

import axios from 'axios'

export default {
  name: 'Audios',


  data () {
      return {
        users: [],
        BuNovo: {
          color:'success',
          'width': '100%',
        }, 
        arquivo:{
          nome:'',
          file:'',
          tipo_arquivo_id:1,
          disciplina:'',

        },
        novo: false,
        file: null,
        users:[],
     
      }
    },
    created(){
     this.all()
    },
  computed: {
    allDisciplinas (){
        return this.$store.state.disciplinas.disciplinas   
    },
     allArquivos (){
        return this.$store.state.arquivos.allaudios   
    },
    
    fields () {
        return [{
          name: '__slot:marker',
          width: '30px',
          dataClass: 'text-center',
        }, {
          name: 'nome',
          title: this.$t('tables.headings.name'),
        }, {
          name: 'nome_original',
          title: this.$t('tables.headings.email'),
        }, {
          name: 'tamanho',
          title: this.$t('tables.headings.country'),
        },{
          name: 'acion',
          dataClass: 'text-right',
          title: this.$t('tables.headings.country'),
         
        }, {
          name: '__slot:actions',
          dataClass: 'text-right',
        }]
    },
  },

  methods: {
    all (){
      this.$store.dispatch('allDisciplinas')
      this.$store.dispatch('allAudios')
    },
      abrirNovo (){
        this.novo = !this.novo
      },

      submitFile (){
         let formData = new FormData();
         formData.append('file', this.file);
         formData.append('nome', this.arquivo.nome);
         formData.append('tipo_arquivo_id', 3);
         formData.append('disciplina_id', this.arquivo.disciplina.id);
         formData.append('tipo', 'audios');

       
           this.$store.dispatch('addArquivo',formData)
                .then(() => {
                    console.log('certo')
                }).catch(() => {
                    console.log('errado')
                })
      
            this.arquivo = {
                      nome:'',
                      file:'',
                      disciplina:'',
                      tipo_arquivo_id:5,
                    }
            this.all()
     
      },

     handleFileUpload(){
        this.file = this.$refs.file.files[0];
      }
  
 
  },
}
</script>

<style lang="scss">

</style>
